import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  wanList: [],
  account: null,
  wan: null,
  error: false,
  loading: false,
  loaded: false,
  realWan: null,
  checkingWan: false,
  timerStart: null,
  podTimer: false,
  rebootPodId: null,
  wifiServiceCheckTimer: false,
  wifiServiceCheckTime: null,
  tenantData: null,
  speedTestResults: null,
  routerSpeedCheckTime: null,
  speedTestResultError: false,
  wscError: false,
};

const resetWanState = (state, action) => {
  return updateObject(state, initialState)
}

const initWanStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    loaded: false,
    wscError: false,
  });
};

const setWan = (state, action) => {
  return updateObject(state, {
    realWan: action.realWan,
    loading: false,
    loaded: true,
    added: false,
    edited: false,
    checkingWan: false,
    timerStart: null,
    wifiServiceCheckTimer: false,
    wifiServiceCheckTime: null
  });
};
const setTenant = (state, action) => {
  return updateObject(state, {
    tenantData: action.tenantData
  })
};

const fetchWanFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true,
  });
};

const fetchWscFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    wscError: true,
  });
};

const restarting = (state, action) => {
  let ts = action.timerStart ? action.timerStart : Date.now();
  return updateObject(state, {
    checkingWan: true,
    timerStart: ts
  });
}

const podRestarting = (state, action) => {
  return updateObject(state, {
    podTimer: true,
    timerStart: Date.now(),
    rebootPodId: action.pSerial
  });
}

const wanConnected = (state, action) => {
  return updateObject(state, {
    checkingWan: false,
    podTimer: false,
    timerStart: null
  })
}

const wifiServiceCheckSpinnerUpdate = (state, action) => {
  return updateObject(state, {
    wifiServiceCheckTimer: true,
    wifiServiceCheckTime: Date.now()
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_WAN_START:
      return initWanStart(state, action);
    case actionTypes.SET_WAN:
      return setWan(state, action);
    case actionTypes.SET_TENANT:
      return setTenant(state, action);
    case actionTypes.FETCH_WAN_FAILED:
      return fetchWanFailed(state, action);
    case actionTypes.FETCH_WSC_FAILED:
      return fetchWscFailed(state, action);
    case actionTypes.RESTARTING:
      return restarting(state, action);
    case actionTypes.POD_RESTARTING:
      return podRestarting(state, action);
    case actionTypes.WAN_CONNECTED:
      return wanConnected(state, action);
    case actionTypes.WAN_WIFI_SERVICE_CHECK_TIMER:
      return wifiServiceCheckSpinnerUpdate(state, action);
    default:
      return state;
  }
};

export default reducer;
